module.exports = __webpack_public_path__ + "static/assets/6d679f3eb6bc8409c53be31aad8b3f86.png";